export default {"src":"/_next/static/media/quotation.9a7ab85e.svg","height":45,"width":44,"blurWidth":0,"blurHeight":0};